import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import wNumb from 'wnumb';

Number.prototype.round = function(places) {
	return +(Math.round(this + "e+" + places)  + "e-" + places);
};

let barConfig = {
	type: 'bar',
	data: {
		datasets: [{
			barThickness: 4,
		}]
	},
	options: {
		events: [],
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: false,
			},
			
		},
		layout: {
			padding: {
				top: 24,
				left: 80
			}
		},
		scales: {
			y: {
				beginAtZero: true,
				display: false,
				grid: {
					drawTicks: false,
					display: false,
				},
				ticks: {
					display: false,
				}
			},
			x: {
				grid: {
					drawTicks: false,
					display: false,
				},
				ticks: {
					// mirror: true,
					padding: 8,
					font: {
						size: 14,
						family: "Akkurat",
					}
				},
			},
		},
		animation: {
			duration: 0,
			onComplete: function(animation) {
				console.log("Anim: ", animation);
				let ctx = animation.chart.ctx,
					chart = animation.chart,
					datasets = animation.chart.config.data.datasets;

				ctx.textAlign = "center";
				ctx.textBaseline = "middle";
				ctx.font = "20px Akkurat";

				datasets.forEach(function (dataset, i) {
					chart.getDatasetMeta(i).data.forEach(function (p, j) {
						console.log("p:", p);
						// ctx.fillStyle = p._model.backgroundColor;
						ctx.fillStyle = p.options.backgroundColor;
						ctx.fillText(datasets[i].data[j], p.x, p.y - 13);
					});
				});
			}
		}
	}
};

let doughnutConfig = {
	type: 'doughnut',
	data: {
		datasets: [{
			barThickness: 4,
			borderWidth: [0,0,0,0],
			hoverBorderWidth: [0,0,0,0],
		}]
	},
	options: {
		cutout: "87%",
		events: [],
		responsive: true,
		maintainAspectRation: false,
		plugins: {
			legend: {
				display: false,
			},

			tooltip: {
				enabled: false,
			}
		},
		layout: {
			padding: {
				// left: 50,
				// right: 50,
			}
		},
		animation: {
			animateScale: false,
			animateRotate: false,
			onComplete: function(animation) {
				let ctx = animation.chart.ctx,
					chart = animation.chart,
					datasets = animation.chart.config.data.datasets;

				ctx.textAlign = "center";
				ctx.textBaseline = "middle";
				ctx.font = "30px Akkurat";

				datasets.forEach(function (dataset, i) {
					let total = dataset.data[1] + dataset.data[2];
					if(typeof total === "number" && !isNaN(total)) {
						ctx.fillStyle = '#2C3643';
						ctx.fillText(dataset.data[1] + dataset.data[2], ctx.canvas.offsetWidth/2, ctx.canvas.offsetHeight/2);
					}
				});
			},
		}
	}
};

export default {
	init: function() {
		if(document.querySelector('.chart--bar') !== null) {
			document.querySelectorAll('.chart--bar').forEach(el => {
				let configData = barConfig,
				dataset = { borderWidth: 0 },
				config,
				legend;

				// Create the data for the chart
				if(typeof el.dataset.values !== 'undefined') {
					configData.data.datasets[0].data = el.dataset.values.split('|');
				}
				if(typeof el.dataset.colors !== 'undefined') {
					configData.data.datasets[0].backgroundColor = el.dataset.colors.split('|');
				}
				if(typeof el.dataset.labels !== 'undefined') {
					configData.data.labels = el.dataset.labels.split('|');
				}
				if(typeof el.dataset.average !== 'undefined') {
					configData.data.showAverage = true;
					configData.data.averageLabel = el.dataset.average;

					if(typeof el.dataset.averageValue !== 'undefined') {
						configData.data.averageValue = el.dataset.averageValue;
					}
				}
				if(typeof el.dataset.sum !== 'undefined') {
					configData.data.showSum = true;
					configData.data.sumLabel = el.dataset.sum;
				}
				if(typeof el.dataset.ignoreWriting !== 'undefined') {
					configData.data.ignoreWriting = true;
				}
				configData.data.datasets.push(dataset);
				config = Object.assign(barConfig, configData);
				console.log("Config: ", config);
				//Create Chart
				el.chart = new Chart(el.getContext('2d'), config);

				// Generate legend and append it to the charts parent
				legend = this.generateLegend(el.chart);
				el.parentElement.insertAdjacentElement('beforeend', legend);
				legend.style.height = legend.offsetHeight + 'px';
				legend.style.bottom = 0;
			});
		}

		if(document.querySelector('.chart--doughnut') !== null) {
			document.querySelectorAll('.chart--doughnut').forEach(el =>{
				let configData = doughnutConfig,
					dataset = { borderWidth: [0,0,0,0], hoverBorderWidth: [0,0,0,0] },
					config,
					legend;

				// Create the data for the chart
				if(typeof el.dataset.values !== 'undefined') {
					let scores = el.dataset.values.split('|');
					configData.data.scores = scores;
					configData.data.datasets[0].data = [
						800 - parseInt(scores[0]),
						parseInt(scores[0]),
						parseInt(scores[1]),
						800 - parseInt(scores[1]),
					];
					// dataset.data = el.dataset.values.split('|');
				}
				if(typeof el.dataset.colors !== 'undefined') {
					let colors = el.dataset.colors.split('|');
					configData.data.datasets[0].backgroundColor = ['#67747c', colors[0], colors[1], '#67747c' ];
				}
				if(typeof el.dataset.labels !== 'undefined') {
					let labels = el.dataset.labels.split('|');
					configData.data.labels = ['', labels[0], labels[1], '' ];
				}
				configData.data.datasets.push(dataset);
				config = Object.assign(doughnutConfig, configData);


				el.chart = new Chart(el.getContext('2d'), config);
				legend = this.generateLegendDoughnut(el.chart);
				el.parentElement.insertAdjacentHTML('beforeend', legend);
			});
		}

		if(document.querySelector('#education-tabs') !== null){
			let tabs = document.querySelectorAll('#education-tabs .tab');
			if(tabs !== null){
				tabs.forEach(el => {
					el.classList.remove('active');
				});
				tabs[0].classList.add('active');
			}
		}
	},
	generateLegend: function(chart) {
		let div = '',
			text = '';

		div = document.createElement('div');
		div.classList.add('chart-sum');

		if(chart.data.datasets.length){
			if(chart.data.ignoreWriting){
				chart.data.datasets[0].data.pop();
			}

			let sum = chart.data.datasets[0].data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
			if(chart.data.showAverage){
				let average = parseFloat(sum / chart.data.datasets[0].data.length);
				average = average.round(2);

				if(typeof chart.data.averageValue !== 'undefined'){
					average = chart.data.averageValue;
				}

				text += `
					<h3>${average}</h3>
					<p>${chart.data.averageLabel}</p>
				`;
			}
			if(chart.data.showSum){
				text += `
					<h3>${sum}</h3>
					<p>${chart.data.sumLabel}</p>
				`;
			}
		}
		div.innerHTML = text;

		return div;
	},
	generateLegendDoughnut: function(chart) {
		let text = '';

		if(chart.data.datasets.length){
			let sum = 0;

			chart.data.datasets[0].data.forEach(no => {
				sum = sum + parseInt(no);
			});

			text = `
				<div class="chart-result right">
					<h3 style="color: ${chart.data.datasets[0].backgroundColor[1]};">${chart.data.scores[0]}</h3>
					<p>${chart.data.labels[1]}</p>
				</div>
				<div class="chart-result">
					<h3 style="color: ${chart.data.datasets[0].backgroundColor[2]};">${chart.data.scores[1]}</h3>
					<p>${chart.data.labels[2]}</p>
				</div>
			`;
		}
		return text;
	}
}

